export const validarHash = (hash) => {
  const lastChar = hash.substr(-1)
  if(lastChar === '/'){
    return hash.slice(0, -1)
  }else{
    return hash
  }
}